// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"6203e814","556":"6203e814","729":"9d9feace","830":"6203e814"}[chunkId] + ".chunk.css";
};